import React from "react";
import { Row, Col, UncontrolledTooltip, UncontrolledCollapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlayCircle,
  faStopCircle,
  faEye,
  faSlidersH,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import { getDateMonthOnly, showMinutesInHoursAndMins, spacebetweenAMPM } from "../common/util/appUtils";

export default function TopPositionTimeTrack({
    timeTrackClock,
    timerObj,
    timeTrackLogs,
    setTimerTimeTrack,
    setTimerPrevTimeTrack,
    startstopClockTimeTrack,
    handleOnOpenTask,
    setDeleteTimeLogObj,
    setTimeDeleteWarn,
    getTaskToolTipLabel, 
}) {
const getTopPositionTimeTrack = (result) => {
    result = _.cloneDeep(result);
    if (timeTrackClock && timerObj) {
      let idx = result.findIndex((one) => one.jobId == timerObj.jobId);
      if (idx !== -1) {
        let firstObj = _.cloneDeep(result[idx]);
        result[idx] = _.cloneDeep(result[0]);
        result[0] = _.cloneDeep(firstObj);
      }
    }
    return result;
  }; 
  return ( 
        getTopPositionTimeTrack(timeTrackLogs).map(
                                          (e, i) => {
                                            return (
                                              <>
                                                <UncontrolledTooltip
                                                  placement="left"
                                                  target={"jobname" + e.jobId}
                                                >
                                                  {getTaskToolTipLabel(e)}
                                                </UncontrolledTooltip>
                                                <Row className="no-gutters user-time-track">
                                                  <Col>
                                                    <tr>
                                                      {" "}
                                                      <td>
                                                        <FontAwesomeIcon
                                                          style={
                                                            timerObj &&
                                                            timeTrackClock &&
                                                            e.jobId == timerObj.jobId
                                                              ? {
                                                                  color: "rgb(204, 45, 45)",
                                                                }
                                                              : {
                                                                  color:
                                                                    "rgb(45, 204, 110)",
                                                                }
                                                          }
                                                          icon={
                                                            timerObj &&
                                                            timeTrackClock &&
                                                            e.jobId == timerObj.jobId
                                                              ? faStopCircle
                                                              : faPlayCircle
                                                          }
                                                          onClick={() => {
                                                            setTimerTimeTrack(e.totaltime);
                                                            setTimerPrevTimeTrack(
                                                              e.totaltime
                                                            );
                                                            // dispatch(addTimer(e.totaltime))
                                                            if (
                                                              timeTrackClock &&
                                                              timerObj &&
                                                              e.jobId == timerObj.jobId
                                                            ) {
                                                              startstopClockTimeTrack(
                                                                timerObj
                                                              );
                                                            } else {
                                                              if (
                                                                timeTrackClock &&
                                                                timerObj
                                                              ) {
                                                                alert(
                                                                  "Another timer is already running"
                                                                );
                                                              } else {
                                                                startstopClockTimeTrack(e);
                                                              }
                                                            }
                                                          }}
                                                        />
                                                      </td>
                                                      <td
                                                        onClick={() => handleOnOpenTask(e)}
                                                        style={{
                                                          maxWidth: "75px",
                                                          cursor: "pointer",
                                                          color: "rgb(24, 144, 255)",
                                                        }}
                                                        className="text-truncate"
                                                        id={"jobname" + e.jobId}
                                                      >
                                                        {e.jobName}
                                                      </td>
                                                      <td className="text-center">
                                                        {showMinutesInHoursAndMins(
                                                          e.totaltime
                                                        )}
                                                      </td> 
                                                    </tr>
                                                   
                                                  </Col>
                                                  <Col sm={3} className="text-right">
                                                    <ul className="list-unstyled">
                                                      <li id={"View" + e.jobId}>
                                                        <FontAwesomeIcon
                                                          icon={faEye}
                                                          className="view"
                                                        />
                                                      </li>
                                                      <li>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                </Row>
                                                <UncontrolledCollapse
                                                  toggler={"View" + e.jobId}
                                                >
                                                  <>
                                                    {e.timearr &&
                                                      e.timearr.map((one) => {
                                                        return (
                                                          <div className="time-tracked-duration time-track-duration-common-app">
                                                            <Row className="no-gutters user-time-track">
                                                              <Col>
                                                                <tr>
                                                                  {" "}
                                                                  <td>
                                                                    {one.timerLog ? (
                                                                      <FontAwesomeIcon
                                                                        icon={faPlayCircle}
                                                                      />
                                                                    ) : (
                                                                      <>
                                                                        <FontAwesomeIcon
                                                                          icon={faSlidersH}
                                                                        />
                                                                      </>
                                                                    )}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      paddingLeft: "15px",
                                                                    }}
                                                                    className="text-center"
                                                                  >
                                                                    {showMinutesInHoursAndMins(
                                                                      one.totaltime
                                                                    )}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      display: "block",
                                                                      width: "100%",
                                                                    }}
                                                                  >
                                                                    {getDateMonthOnly(
                                                                      new Date(one.workDate)
                                                                    )}
                                                                  </td>
                                                                  <td>
                                                                    <FontAwesomeIcon
                                                                      id={
                                                                        "view" + one.timerId
                                                                      }
                                                                      icon={faEye}
                                                                    />
                                                                  </td>
                                                                  <td>
                                                                    <FontAwesomeIcon
                                                                      id={"Del" + e.timerId}
                                                                      icon={faTrashAlt}
                                                                      className="delete"
                                                                      onClick={() => {
                                                                        setDeleteTimeLogObj(
                                                                          one
                                                                        );
                                                                        setTimeDeleteWarn(
                                                                          true
                                                                        );
                                                                      }}
                                                                    />
                                                                  </td>
                                                                </tr>
                                                              </Col>
                                                                                                                  </Row>
                                                            <UncontrolledCollapse
                                                              toggler={"view" + one.timerId}
                                                            >
                                                              {one.timers &&
                                                                one.timers.map((obj) => {
                                                                  return (
                                                                    <>
                                                                      <div className="time-tracked-duration">
                                                                        <p>
                                                                          <span>
                                                                            From :
                                                                          </span>{" "}
                                                                          {spacebetweenAMPM(
                                                                            obj.fromTimeInTimeFormat
                                                                          )}
                                                                        </p>
                                                                        <p>
                                                                          <span>To :</span>{" "}
                                                                          {spacebetweenAMPM(
                                                                            obj.toTimeInTimeFormat
                                                                          )}
                                                                        </p>
                                                                      </div>
                                                                    </>
                                                                  );
                                                                })}
                                                            </UncontrolledCollapse>
                                                          </div>
                                                        );
                                                      })}
                                                  </>
                                                </UncontrolledCollapse>
                                              </>
                                            );
                                          }
                                        )
  )
}
